export default __webpack_public_path__ + "static/media/Bash.39616ecd.png";